<div class="row w-100 m-0 position-relative mb-4 bots-header">
    <div class="col-md-12 p-0 ml-auto" style="position: relative;">
        <!-- Search -->
        <div class="row list-header my-0">
            <div class="col-md-12 col-xl-8 mt-3">
                <div class="list-search-container" (click)="$event.stopPropagation()">
                    <i class="fas fa-search list-search-icon"></i>
                    <form class="list-search-form align-items-center">
                        <input placeholder="{{ 'Search' | translate }}" class="list-search-input"
                            (click)="$event.stopPropagation()" (input)="searchTextChanged($event.target.value)"
                            [(ngModel)]="searchValue" name="searchLink" type="text" />
                        <i *ngIf="searchValue" (click)="resetSearch()"
                            class="fas fa-times btn-xs btn-bordered btn-danger btn-icon float-right nglist-item-action remove__icon mr-2"
                            aria-hidden="true"></i>
                    </form>
                    <button (click)="createLink($event)" class="btn btn-sm btn-primary mr-1">{{'Add' |
                        translate}}</button>
                </div>
            </div>
        </div>
    </div>

    <div class="col-md-12 p-0 ml-auto aligned padding mt-3">
        <app-list-grid [items]="bots" [headingText]="'External Links' | translate"
            [elementsNumber]="'(' + bots.length + ')'" [headingTextSize]="'SMALL'"
            botType="link" [botCounters]=true [showStatus]="true"
            [createText]="'Add Link' | translate" [addText]="'to add a new link' | translate"
            [createNewText1Part]="'Select an existing link or click on' | translate"
            [createNewText2Part]="'to create a new link' | translate" [editText]="'to edit the link' | translate"
            [deleteText]="'to delete the link' | translate"
            [operationalText]="'to make the link operational or not' | translate" [showOperational]="false"
            [toggleIcons]="false" [statusIcons]="false"
            [badgeIcons]="false" [inlineAdd]="false" [listToggle]="false" [expanded]="true"
            [hideSearch]="true" [showAddWithoutSearch]="false"
            [navigationEdit]="false" [showAttributes]="true" [showHeader]="true" [hasPagination]="false"
            [customFilter]="searchValue" (createFunction)="createLink($event)" (editFunction)="editLink($event)"
            (deleteFunction)="deleteLink($event)">
            <a (click)="createLink($event)" class="btn list-search-add">{{'Add' | translate}}</a>
        </app-list-grid>
    </div>
</div>

<drawer [title]="(selectedBot.id ? 'Edit Link' : 'Add Link') | translate" [isClosed]="isDrawerClosed"
    (closeEvent)="closeDrawer()" (saveEvent)="saveLink()" (cancelEvent)="closeDrawer()" [hideDelete]="true">
    <div class="container-fluid">
        <role-bot-manage *ngIf="!isDrawerClosed" [bot]="selectedBot" [serviceId]="serviceId" [fromRole]="false"
            [showBotAdd]="!selectedBot.id" (changedData)="onBotSaved()" (modalAddedEvent)="onBotSaved()">
        </role-bot-manage>
    </div>
</drawer>